module.exports = __webpack_public_path__ + "img/RDA_tipo1_4pax_48m2.11744485.png";